import { render, staticRenderFns } from "./AddCampoModal.vue?vue&type=template&id=c335da62"
import script from "./AddCampoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCampoModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports